import React from 'react';
import {
    Col, Form, FormGroup, FormControl, ControlLabel,
} from 'react-bootstrap';

class CriteriaPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: [],
    };
    this.onChangeFields = this.onChangeFields.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
  }
  componentDidMount() {
    // inicializar array de errores
    const errorArray = [];
    this.props.evaluacion.forEach((item) => {
      errorArray.push(false);
    });
    this.setState({ error: errorArray });
  }
  generateForms() {
    const html = [];
    this.props.evaluacion.forEach((item, index) => {
      html.push(
        <FormGroup key={index} validationState={this.state.error[index] ? 'error': null}>
          <Col componentClass={ControlLabel} md={8} style={{textAlign:'left'}}>
            {item.criterio}
          </Col>
          <Col md={4}>
            <FormControl
              type="number" value={item.valor ? item.valor : ''}
              onChange={(e) => this.onChangeFields(e.target.value, index, item.idcriterio)}
            />
          </Col>
        </FormGroup>
      );
    });
    return html;
  }
  onChangeFields(value, index, idcriterio) {
    let auxStateError = this.state.error;
    if (value < 0 || value > 10) {
      auxStateError[index] = true;
    } else {
      auxStateError[index] = false;
    }
    this.setState({ error: auxStateError }, this.checkErrors());
    this.props.handleOnChangeFields(value, index, idcriterio);
  }
  checkErrors() {
    let error = false;
    this.state.error.forEach((item) => {
      if (item) {
        error =  true;
      }
    });
    this.props.setError(error);
  }
  getSubTotal() {
    const evaluacion = this.props.evaluacion;
    evaluacion.forEach((item, index) => {
      if (!item.valor) {
        evaluacion[index].valor = 0;
      }
    });
    let subtotal = (0.3*parseInt(evaluacion[0].valor, 10)) +
                    (0.2*parseInt(evaluacion[1].valor, 10)) +
                    (0.2*parseInt(evaluacion[2].valor, 10)) +
                    (0.15*parseInt(evaluacion[3].valor, 10)) +
                    (0.1*parseInt(evaluacion[4].valor, 10)) +
                    (0.05*parseInt(evaluacion[5].valor, 10));
    subtotal = +subtotal.toFixed(2);
    return subtotal;
  }
  render() {
    return (
      <Form horizontal={true}>
        {this.generateForms()}
        <FormGroup>
          <Col componentClass={ControlLabel} md={8} style={{textAlign:'left'}}>
            Subtotal
          </Col>
          <Col md={4}>
            <div style={{ paddingTop: '9px', paddingLeft: '15px' }}>
              {this.props.error ? '?' : this.getSubTotal()}
            </div>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

export default CriteriaPanel;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreSelectionComponents/CriteriaPanel.jsx